import { InteractiveBadge } from "@moe/priv/components/interactive-badge";
import { Badge } from "@moe/priv/model/profile";

interface Value {
  src: string;
  title: string;
  description: string;
}

const map: Record<Badge, Value> = {
  "winter-event-2024": {
    src: "/winter-event-2024-badge.png",
    title: "Winter Event 2024 Winner!",
    description: "Won the character creation winter event in 2024!"
  }
};

interface Props {
  badges: Badge[];
}

export function Badges({ badges }: Props) {
  return (
    <div className="flex flex-wrap gap-2">
      {badges.map((badge) => {
        const v = map[badge];
        return (
          <div key={badge} className="flex flex-col items-center gap-2">
            <InteractiveBadge src={v.src} title={v.title} description={v.description} />
            <h2 className="text-tx-secondary text-sm font-bold">{v.title}</h2>
          </div>
        );
      })}
    </div>
  );
}
